module.exports = __webpack_public_path__ + "static/media/YF47_1.1b5d0476.jpg";